export type PortalId = 'admin' | 'dashboard' | 'operadores' | 'proveedores';

export interface Portal {
  readonly id: PortalId;
  readonly name: string;
  readonly tagline: string;
  readonly url: string;
  /** Hex color shared by the WebGL scene lighting and the card styling. */
  readonly accent: string;
}

/** URLs still holding their scaffold placeholder must not be opened. */
export function isPortalConfigured(portal: Portal): boolean {
  return !!portal.url && !portal.url.startsWith('TODO_');
}
